module.exports = __webpack_public_path__ + "static/img/b6-1.dfd4ba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b6-1.png
// module id = AgN2
// module chunks = 1